import { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { GoogleMap, Marker } from "@react-google-maps/api";
import {
  ArrowToLeft,
  BathsIcon,
  BedsIcon,
  CheckInIcon,
  // CheckOutIcon, // Unused import
  // GroundRuleIcon, // Unused import
  NibiruIcon,
  NUSDIcon,
  UsersIcon,
} from "../../AssetComponents/Images";
import {
  PinIcon,
  MapMinusIcon,
  MapPlusIcon,
} from "../../AssetComponents/Images";
import { PurpleButton } from "../../Components/Buttons/PurpleButton";
import { BlackButton } from "../../Components/Buttons/BlackButton";
import { NumberSpin } from "../../Components/Spin/NumberSpin";
import { Review } from "../../Components/Review/Review";
import { PickDate } from "../../Components/Reserve/PickDate";
// import { Toggle } from "../../Components/Toggle/Toggle"; // Unused import
import { DisabledButton } from "../../Components/Buttons/DisabledButton";
import { getChatId } from "../../Components/functions/Functions";
import { mapStyles } from "../../Components/GoogleMap/Style";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-responsive-modal";
import { toast } from "react-toastify";
import { api } from "../../Components/functions/Api";
import { updateNFTStore } from "../../ReduxSlices/NFTSlice";
import {
  getProfileFromWallet,
  truncateWalletAddress,
  updateToken,
} from "../../Components/functions/Functions";
import {
  setReservationGuests,
  setReservationFee,
} from "../../ReduxSlices/ReservationSlice";
import mapPinIcon from "../../assets/images/Dashboard/Dashboard/mappin.svg";
import { Fade } from "react-awesome-reveal";
import { GreenButton } from "../../Components/Buttons/GreenButton";
import { ProfileRequiredModal } from "../../Components/Rent/ProfileRequiredModal";
import {
  executeRentalWithWallet,
  queryContract,
} from "../../Components/functions/Contract";
import { Mainnet } from "@nibiruchain/nibijs";
import { TransactionErrorModal } from "../../Components/ErrorDisplay/TransactionErrorModal";
import { PropertyImageWithFallback } from "../../Components/Images/PropertyImageWithFallback";

// Import all amenities components
import {
  BathHanger, Bathub, HairDryer, Heating, HotWater, Shower, SoapDrop, ToiletSeat,
} from "../../Components/Amenities/Bathroom";
import {
  Balcony, Park, SwimmingPool, ValleyView,
} from "../../Components/Amenities/View";
import {
  Bed, BedDouble, BedroomHanger, DresserDrawer, DressingMirror, SafeBox, SofaDouble, TrowelBrush, WashingMachine,
} from "../../Components/Amenities/Bedroom";
import { GamePad } from "../../Components/Amenities/Entertainment";
import {
  Alarm, CCTV, FireExtinguisher, MedicalCase, TvStand,
} from "../../Components/Amenities/HomeSafety";
import {
  LaptopTable, Wifi, WorkJob,
} from "../../Components/Amenities/InternetAndOffice";
import {
  Blender, CoffeeMachine, Dishes, DishWasher, ForkKnife, Fridge, Induction, Kitchen, PlateFork, SaltPepper, Stove, TableChair, Trash, WineGlass,
} from "../../Components/Amenities/Kitchen";
import {
  BeachUmbrella, ChildrenSlide, Lounge, Sun, Swing,
} from "../../Components/Amenities/Outdoor";
import { Parking } from "../../Components/Amenities/Parking";
import {
  Breakfast, CampFire, Cat, CleaningSprayAction, Dog, HouseKey, Longterm, ManStaff, Smoking, Stairs, Userprofile,
} from "../../Components/Amenities/Services.";
import {
  BabyBedroom, BookFairyTale, ToyCubes,
} from "../../Components/Amenities/Family";
import {
  AirConditioning, Beach, BeachView, BedLinenTowels, CableTv, CarbonMonoxideDetector, CityView, CleaningProducts, CoffeeMaker, ComplimentarySoapShampooConditioner, CookingBasics, CookwareKitchenUtensils, CrockeryCutlery, DiningTable, DryingRack, Elevator, Essentials, FamilyKidsFriendly, FirstAidKit, FreeParkingWithGarage, Gym, Hangers, IronIroningBoard, Kettle, Marina, MarinaView, Microwave, NoParties, Oven, PlayGround, Reception, Refrigerator, RoomDarkeningShades, Seaview, SmartTv, SmokeDetectors, SmokingNotAllowed, StreamingServiceSuchAsNetflix, Toaster, Toilet, TrashCans, Wardrobe, WineGlasses, WirelessInternet,
} from "../../Components/Amenities/Others";
import { Appliance, Fan } from "../../Components/Amenities/HeatingandCooling";

export const DetailsMobile = () => {
  // Updated with full host functionality - v2.0
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [amenitiesShow, setAmenitiesShow] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [zoom, setZoom] = useState(14);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showImageModal, setShowImageModal] = useState(false);
  
  const reservation_guests = useSelector((state) => state.reservation.guests);
  const reservation_period = useSelector((state) => state.reservation.period);
  const fee = useSelector((state) => state.reservation.fee);
  const feeBps =
    Number.isFinite(Number(fee)) && Number(fee) >= 0
      ? Number(fee)
      : Number(process.env.REACT_APP_PLATFORM_FEE_BPS) || 300;
  const diff = useSelector((state) => state.time.diffToUTC);
  const account = useSelector((state) => state.auth.account);
  const token = useSelector((state) => state.nft.nfts[params.id]);
  const wallet = useSelector((state) => state.auth.wallet);
  const myProfile = useSelector((state) => state.auth.profile);
  const mainnet = Mainnet();
  
  const [profile, setProfile] = useState();
  const [listingDetails, setListingDetails] = useState({
    currency: process.env.REACT_APP_USDC_DENOM,
    price_per_day: token?.short?.price_per_day || 70,
    minimum_stay: token?.short?.minimum_stay || 1,
    cancellation: token?.short?.cancellation || [
      {
        deadline: 15,
        percentage: 90,
      },
      {
        deadline: 3,
        percentage: 7,
      },
    ],
  });
  const [cancellationTemp, setCancellationTemp] = useState({
    percentage: null,
    deadline: null,
  });

  // Update listing details when token loads
  useEffect(() => {
    if (token?.short) {
      // Use price from token (already normalized from backend)
      // If price looks like raw contract format (>= 1000 and whole number), convert it
      let pricePerDay = token.short.price_per_day || 70;
      const usdcDecimals = Number(process.env.REACT_APP_USDC_DECIMALS) || 6;
      
      // Check if price is in raw format (>= 1000 and is a whole number)
      if (pricePerDay >= 1000 && Number.isInteger(Number(pricePerDay))) {
        // Convert from raw contract format to display format
        // 500000 = 0.5 USDC, 70000000 = 70 USDC
        pricePerDay = pricePerDay / (10 ** usdcDecimals);
      }
      
      setListingDetails({
        currency: process.env.REACT_APP_USDC_DENOM,
        price_per_day: pricePerDay,
        minimum_stay: token.short.minimum_stay || 1,
        cancellation: token.short.cancellation || [
          {
            deadline: 15,
            percentage: 90,
          },
          {
            deadline: 3,
            percentage: 7,
          },
        ],
      });
    }
  }, [token]);

  const getToken = async () => {
    if (!token) {
      try {
        const propertyData = await api("property/getProperty", {
          token_id: params.id,
        });
        if (propertyData) {
          dispatch(
            updateNFTStore({
              token_id: params.id,
              metaData: propertyData.metaData,
              short: propertyData.short,
              rentals: propertyData.rentals,
              access: propertyData.access,
              icalSync: propertyData.icalSync || null,
              manuallyBlockedDates: propertyData.manuallyBlockedDates || [],
            })
          );
        }
      } catch (error) {
        console.error("Failed to get property from backend:", error);
        await updateToken(
          {
            token_id: params.id,
            contract: process.env.REACT_APP_RENTAL_SMART_CONTRACT,
          },
          mainnet.endptTm,
          dispatch
        );
      }
    }
  };

  const getProfile = async (wallet) => {
    if (!wallet || wallet === account) return;
    const profile = await getProfileFromWallet(wallet);
    setProfile(profile);
  };

  const getFeePercentage = async () => {
    const fallbackFeeBps =
      Number(process.env.REACT_APP_PLATFORM_FEE_BPS) || 300; // basis points, e.g. 300 = 3%
    try {
      const res = await queryContract(
        process.env.REACT_APP_RENTAL_SMART_CONTRACT,
        { get_fee: {} },
        mainnet.endptTm
      );
      const feeBps =
        typeof res === "object" && res !== null && "fee" in res
          ? Number(res.fee)
          : Number(res);
      const value = Number.isFinite(feeBps) ? feeBps : fallbackFeeBps;
      dispatch(setReservationFee(value));
    } catch (_) {
      dispatch(setReservationFee(fallbackFeeBps));
    }
  };

  const handleAddItem = () => {
    const updatedCancellation = listingDetails.cancellation.slice();
    for (let i = 0; i < updatedCancellation.length; i++) {
      if (
        Number(updatedCancellation[i].deadline) ===
          Number(cancellationTemp.deadline) ||
        Number(updatedCancellation[i].percentage) ===
          Number(cancellationTemp.percentage)
      ) {
        return;
      }
    }
    updatedCancellation.push({
      deadline: Number(cancellationTemp.deadline),
      percentage: Number(cancellationTemp.percentage),
    });
    const sortByDeadline = updatedCancellation.slice();
    const sortByPercentage = updatedCancellation.slice();

    sortByPercentage.sort((a, b) => b.percentage - a.percentage);
    sortByDeadline.sort((a, b) => b.deadline - a.deadline);

    if (JSON.stringify(sortByDeadline) === JSON.stringify(sortByPercentage)) {
      setListingDetails({ ...listingDetails, cancellation: sortByDeadline });
    }
  };

  const handleListNFT = async () => {
    const listingMessage = {
      set_list_for_short_term_rental: {
        token_id: params.id.toString(),
        denom: listingDetails.currency.toString(),
        price_per_day:
          Number(listingDetails.price_per_day) *
          10 ** process.env.REACT_APP_USDC_DECIMALS,
        auto_approve: false,
        available_period: [],
        minimum_stay: listingDetails.minimum_stay,
        cancellation: listingDetails.cancellation,
      },
    };

    const currentTime = new Date(
      (Math.floor(new Date().getTime() / 1000) + diff) * 1000
    );

    const txHash = await executeRentalWithWallet({
      emailData: null,
      funds: null,
      currentTime,
      chainId: mainnet.chainId,
      endpt: mainnet.endptTm,
      contractAddr: process.env.REACT_APP_RENTAL_SMART_CONTRACT,
      dispatch,
      tokenId: params.id,
      receiver: account,
      CONTRACT_MESSAGE: listingMessage,
      account,
      walletType: wallet,
      walletEx: wallet,
      tokenToSend: null,
    });

    if (txHash) navigate(location.pathname.replace("/" + params.id, ""));
  };

  const handleUnlist = async () => {
    const message = {
      set_unlist_for_shortterm_rental: {
        token_id: params.id,
      },
    };
    const currentTime = new Date(
      (Math.floor(new Date().getTime() / 1000) + diff) * 1000
    );

    const txHash = await executeRentalWithWallet({
      emailData: null,
      funds: null,
      currentTime,
      chainId: mainnet.chainId,
      endpt: mainnet.endptTm,
      contractAddr: process.env.REACT_APP_RENTAL_SMART_CONTRACT,
      dispatch,
      tokenId: params.id,
      receiver: account,
      CONTRACT_MESSAGE: message,
      account,
      walletType: wallet,
      walletEx: wallet,
      tokenToSend: null,
    });

    if (txHash) navigate(location.pathname.replace("/" + params.id, ""));
  };

  const handleEdit = () => {
    const hasActiveRentals = (token?.rentals?.rentals?.length || 0) > 0;
    if (hasActiveRentals)
      toast.error("You cannot edit metadata as active rental exists.");
    else navigate(location.pathname + "/edit");
  };

  useEffect(() => {
    getToken();
  }, []);

  useEffect(() => {
    getProfile(token?.access?.owner);
  }, [token]);

  useEffect(() => {
    getFeePercentage();
  }, []);

  // Get unique images directly without useEffect - using conditional rendering
  const getUniqueImages = () => {
    if (token?.metaData?.images) {
      const images = token?.metaData?.images;
      // Remove duplicates while preserving order
      return images.filter((image, index, self) => 
        self.indexOf(image) === index
      );
    }
    return [];
  };

  // Get images directly
  const loadedImages = getUniqueImages();

  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setShowImageModal(true);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => 
      prev === loadedImages.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => 
      prev === 0 ? loadedImages.length - 1 : prev - 1
    );
  };

  const renderTextWithLineBreaks = (text) => {
    return text?.split("\n").map((line, index) => (
      <span key={index}>
        {line}
        <br />
      </span>
    ));
  };

  // Amenities mapping function
  const renderAmenity = (item) => {
    const amenityMap = {
      "CookwareKitchenUtensils": <CookwareKitchenUtensils />,
      "DryingRack": <DryingRack />,
      "CableTv": <CableTv />,
      "Toaster": <Toaster />,
      "Wardrobe": <Wardrobe />,
      "DiningTable": <DiningTable />,
      "Reception": <Reception />,
      "CityView": <CityView />,
      "SmokeDetectors": <SmokeDetectors />,
      "MarinaView": <MarinaView />,
      "Gym": <Gym />,
      "CarbonMonoxideDetector": <CarbonMonoxideDetector />,
      "Hangers": <Hangers />,
      "TrashCans": <TrashCans />,
      "WineGlasses": <WineGlasses />,
      "StreamingServiceSuchAsNetflix": <StreamingServiceSuchAsNetflix />,
      "CrockeryCutlery": <CrockeryCutlery />,
      "Toilet": <Toilet />,
      "Oven": <Oven />,
      "CoffeeMaker": <CoffeeMaker />,
      "ComplimentarySoapShampooConditioner": <ComplimentarySoapShampooConditioner />,
      "BeachView": <BeachView />,
      "Elevator": <Elevator />,
      "WirelessInternet": <WirelessInternet />,
      "FreeParkingWithGarage": <FreeParkingWithGarage />,
      "SmartTv": <SmartTv />,
      "FireExtinguisher": <FireExtinguisher />,
      "Marina": <Marina />,
      "RoomDarkeningShades": <RoomDarkeningShades />,
      "IronIroningBoard": <IronIroningBoard />,
      "BedLinenTowels": <BedLinenTowels />,
      "Kettle": <Kettle />,
      "Microwave": <Microwave />,
      "AirConditioning": <AirConditioning />,
      "Seaview": <Seaview />,
      "Beach": <Beach />,
      "PlayGround": <PlayGround />,
      "Refrigerator": <Refrigerator />,
      "FamilyKidsFriendly": <FamilyKidsFriendly />,
      "NoParties": <NoParties />,
      "Essentials": <Essentials />,
      "CleaningProducts": <CleaningProducts />,
      "FirstAidKit": <FirstAidKit />,
      "CookingBasics": <CookingBasics />,
      "SmokingNotAllowed": <SmokingNotAllowed />,
      "bathub": <Bathub />,
      "hairdryer": <HairDryer />,
      "shower": <Shower />,
      "hotwater": <HotWater />,
      "soapdrop": <SoapDrop />,
      "heating": <Heating />,
      "toiletseat": <ToiletSeat />,
      "bathhanger": <BathHanger />,
      "swimmingpool": <SwimmingPool />,
      "valleyview": <ValleyView />,
      "park": <Park />,
      "balcony": <Balcony />,
      "trowelbrush": <TrowelBrush />,
      "hanger": <BedroomHanger />,
      "beddouble": <BedDouble />,
      "bed": <Bed />,
      "dresserdrawer": <DresserDrawer />,
      "dressingmirror": <DressingMirror />,
      "safebox": <SafeBox />,
      "sofadouble": <SofaDouble />,
      "washingmachine": <WashingMachine />,
      "gamepad": <GamePad />,
      "medicalcase": <MedicalCase />,
      "fireextinguisher": <FireExtinguisher />,
      "tvstand": <TvStand />,
      "alarm": <Alarm />,
      "cctv": <CCTV />,
      "wifi": <Wifi />,
      "workjob": <WorkJob />,
      "laptoptable": <LaptopTable />,
      "kitchen": <Kitchen />,
      "forkknife": <ForkKnife />,
      "stove": <Stove />,
      "induction": <Induction />,
      "dishes": <Dishes />,
      "fridge": <Fridge />,
      "tablechair": <TableChair />,
      "coffeemachine": <CoffeeMachine />,
      "blender": <Blender />,
      "saltpepper": <SaltPepper />,
      "dishwasher": <DishWasher />,
      "wineglass": <WineGlass />,
      "trash": <Trash />,
      "platefork": <PlateFork />,
      "childrenslide": <ChildrenSlide />,
      "lounge": <Lounge />,
      "swing": <Swing />,
      "sun": <Sun />,
      "beachumbrella": <BeachUmbrella />,
      "parking": <Parking />,
      "cat": <Cat />,
      "dog": <Dog />,
      "breakfast": <Breakfast />,
      "longterm": <Longterm />,
      "housekey": <HouseKey />,
      "userprofile": <Userprofile />,
      "cleaningspray": <CleaningSprayAction />,
      "smoking": <Smoking />,
      "campfire": <CampFire />,
      "stairs": <Stairs />,
      "manstaff": <ManStaff />,
      "toyscubes": <ToyCubes />,
      "fairytale": <BookFairyTale />,
      "babybedroom": <BabyBedroom />,
      "appliance": <Appliance />,
      "fan": <Fan />,
    };
    
    return amenityMap[item] || null;
  };

  return (
    <div className="select-none w-full overflow-auto max-h-[calc(100vh-80px)] h-full p-[6px] sm:p-[10px]">
      <div className="w-full h-full space-y-[12px] sm:space-y-[20px] rounded-[10px] p-[4px] sm:p-[8px] flex flex-col">
        {/* Header with back button */}
        <div className="bg-white border border-[#E3E3E3] rounded-[10px] p-3 shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate(location.pathname.replace("/" + params.id, ""))}
              className="flex items-center gap-1 text-gray-700 hover:text-gray-900 flex-shrink-0"
            >
              <ArrowToLeft className="w-4 h-4" />
              <span className="text-xs font-medium">Back</span>
            </button>
            <div className="text-xs font-medium text-gray-900 truncate mx-2 flex-1 text-center">
              {token?.metaData?.buildingName}
            </div>
            <div className="w-12 flex-shrink-0"></div>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 overflow-y-auto">
          <Fade cascade damping={0.01}>

                  
          <div className="relative bg-white">
            {/* Main large image */}
            <div className="relative h-80 overflow-hidden">
              {loadedImages.length > 0 ? (
                <PropertyImageWithFallback
                  src={loadedImages[currentImageIndex]}
                  alt={`${token?.metaData?.buildingName} - Image ${currentImageIndex + 1}`}
                  className="w-full h-full transition-opacity duration-300 cursor-pointer"
                  priority={true}
                  lazy={false}
                  progressive={false}
                  onClick={() => setShowImageModal(true)}
                />
              ) : (
                <div className="w-full h-full bg-gray-200 flex items-center justify-center">
                  <span className="text-gray-500">Loading images...</span>
                </div>
              )}
              
              {/* Image navigation dots - Only show if multiple images */}
              {loadedImages.length > 1 && (
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
                  {loadedImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentImageIndex(index)}
                      className={`w-3 h-3 rounded-full transition-all duration-200 ${
                        index === currentImageIndex ? 'bg-white shadow-lg scale-110' : 'bg-white/50 hover:bg-white/70'
                      }`}
                    />
                  ))}
                </div>
              )}

              {/* Image count indicator - Only show if multiple images */}
              {loadedImages.length > 1 && (
                <div className="absolute top-4 right-4 bg-black/70 text-white text-xs px-3 py-1 rounded-full font-medium backdrop-blur-sm">
                  {currentImageIndex + 1} / {loadedImages.length}
                </div>
              )}

              {/* Price overlay */}
              <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm rounded-lg px-3 py-2 shadow-lg">
                <div className="text-lg font-bold text-gray-900">
                  ${token?.short?.price_per_day}
                </div>
                <div className="text-xs text-gray-600">per night</div>
              </div>

              {/* Swipe navigation arrows - Only show if multiple images */}
              {loadedImages.length > 1 && (
                <>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setCurrentImageIndex(prev => prev === 0 ? loadedImages.length - 1 : prev - 1);
                    }}
                    className="absolute left-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-black/30 hover:bg-black/50 text-white rounded-full flex items-center justify-center transition-all duration-200 backdrop-blur-sm"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      setCurrentImageIndex(prev => prev === loadedImages.length - 1 ? 0 : prev + 1);
                    }}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-black/30 hover:bg-black/50 text-white rounded-full flex items-center justify-center transition-all duration-200 backdrop-blur-sm"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </>
              )}
            </div>

            {/* Enhanced Scrollable Thumbnail strip - Only show available images */}
            {loadedImages.length > 1 && (
              <div className="relative">
                <div className="flex gap-3 p-4 overflow-x-auto bg-white scrollbar-hide scroll-smooth">
                  {loadedImages.map((image, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentImageIndex(index)}
                      className={`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 transition-all duration-300 transform ${
                        index === currentImageIndex 
                          ? 'border-blue-500 shadow-lg scale-110 ring-2 ring-blue-200' 
                          : 'border-gray-200 hover:border-gray-300 hover:scale-105'
                      }`}
                    >
                      <PropertyImageWithFallback
                        src={image}
                        alt={`Thumbnail ${index + 1}`}
                        className="w-full h-full"
                      />
                    </button>
                  ))}
                </div>
                
                {/* Scroll indicators */}
                <div className="absolute left-0 top-1/2 transform -translate-y-1/2 w-8 h-8 bg-gradient-to-r from-white to-transparent pointer-events-none" />
                <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-8 h-8 bg-gradient-to-l from-white to-transparent pointer-events-none" />
              </div>
            )}
          </div>

        {/* Content */}
        <div className="px-4 py-6 space-y-6">
          {/* Property Info - Compact Address */}
          <div className="bg-white rounded-xl p-4 shadow-sm">
            <div className="mb-3">
              <h1 className="text-xl font-bold text-gray-900 mb-2">
                {token?.metaData?.buildingName}
              </h1>
              {/* Compact address display */}
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <PinIcon className="w-4 h-4 flex-shrink-0" />
                <span className="truncate">{token?.metaData?.addressString}</span>
              </div>
            </div>

            {/* Host info */}
            {!location.pathname.includes("dashboard/host") && (
              <div className="flex items-center justify-between py-2 border-t border-gray-100">
                <div className="flex items-center gap-2 flex-1 min-w-0">
                  {profile?.Avatar ? (
                    <img
                      alt="Host"
                      className="w-8 h-8 rounded-full flex-shrink-0"
                      src={profile.Avatar}
                    />
                  ) : (
                    <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0">
                      <span className="text-gray-500 text-xs">👤</span>
                    </div>
                  )}
                  <div className="min-w-0 flex-1">
                    <div className="font-semibold text-xs truncate">
                      {profile?.Name ? profile.Name.replace("/", " ") : "Host"}
                    </div>
                    <div className="text-xs text-gray-500 truncate">
                      {truncateWalletAddress(token?.access?.owner)}
                    </div>
                  </div>
                </div>
                <PurpleButton
                  onClick={async () => {
                    try {
                      if (!myProfile) {
                        setShowProfileModal(true);
                        return;
                      }
                      
                      await api("user/login", { account: account });
                      
                      let path = "/dashboard/traveler/inbox";
                      
                      const chat = await getChatId(
                        account,
                        token?.access.owner,
                        params.id,
                        "short"
                      );

                      if (chat) {
                        navigate(path + "?chat=" + chat);
                      } else {
                        navigate(
                          path + `?id=${params.id}&receiver=${token?.access.owner}`
                        );
                      }
                      
                    } catch (error) {
                      console.error("Chat navigation error:", error);
                      toast.error("Failed to open chat");
                    }
                  }}
                  text="Contact"
                  className="px-2 py-1 text-xs h-7 flex-shrink-0"
                />
              </div>
            )}
          </div>

          {/* Property Details */}
          <div className="bg-white rounded-xl p-4 shadow-sm">
            <h2 className="text-lg font-semibold mb-4">Property Details</h2>
            <div className="grid grid-cols-2 gap-4">
              <div className="flex items-center gap-3">
                <BedsIcon className="w-6 h-6 text-gray-600" />
                <div>
                  <div className="text-sm font-medium">{token?.metaData?.essentials?.bedrooms}</div>
                  <div className="text-xs text-gray-500">Bedrooms</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <BathsIcon className="w-6 h-6 text-gray-600" />
                <div>
                  <div className="text-sm font-medium">{token?.metaData?.essentials?.bathrooms}</div>
                  <div className="text-xs text-gray-500">Bathrooms</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <UsersIcon className="w-6 h-6 text-gray-600" />
                <div>
                  <div className="text-sm font-medium">{token?.metaData?.essentials?.guests}</div>
                  <div className="text-xs text-gray-500">Max Guests</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <CheckInIcon className="w-6 h-6 text-gray-600" />
                <div>
                  <div className="text-sm font-medium">After {token?.metaData?.checkIn}</div>
                  <div className="text-xs text-gray-500">Check-in</div>
                </div>
              </div>
            </div>
          </div>



          {/* Amenities */}
          <div className="bg-white rounded-xl p-4 shadow-sm">
            <h2 className="text-lg font-semibold mb-4">Amenities</h2>
            <div className="grid grid-cols-2 gap-3">
              {token?.metaData?.amenities && Object.entries(token?.metaData?.amenities).map(([category, items]) =>
                items.slice(0, 6).map((item) => (
                  <div key={item} className="flex items-center gap-2 text-sm">
                    {renderAmenity(item)}
                  </div>
                ))
              )}
            </div>
            {token?.metaData?.amenities && Object.values(token?.metaData?.amenities).flat().length > 6 && (
              <div className="mt-4 w-full">
                <BlackButton
                  text={<div className="w-full text-center">Show All amenities</div>}
                  onClick={() => setAmenitiesShow(true)}
                />
              </div>
            )}
          </div>

          {/* Cancellation Policy */}
          <div className="bg-white rounded-xl p-4 shadow-sm">
            <h2 className="text-lg font-semibold mb-3">Cancellation Policy</h2>
            <div className="text-sm text-gray-700 leading-relaxed">
              {renderTextWithLineBreaks(token?.metaData?.cancellation)}
            </div>
          </div>

          {/* Ground Rules */}
          <div className="bg-white rounded-xl p-4 shadow-sm">
            <h2 className="text-lg font-semibold mb-3">Ground Rules</h2>
            <div className="text-sm text-gray-700 leading-relaxed">
              {renderTextWithLineBreaks(token?.metaData?.groundRule)}
            </div>
          </div>

          {/* Host Actions (if host view) */}
          {location.pathname.includes("dashboard/host") && (
            <div className="bg-white rounded-xl p-4 shadow-sm">
              <h2 className="text-lg font-semibold mb-4">Property Listing Details</h2>
              
              {/* Currency */}
              <div className="space-y-2 mb-4">
                <div className="text-sm font-medium">Currency</div>
                <div className="px-3 py-3 rounded-lg bg-gray-50 border border-gray-200">
                  <div className="flex items-center gap-2">
                    <NUSDIcon className="w-4 h-4" />
                    <span className="text-sm font-medium">USDC</span>
                  </div>
                </div>
              </div>

              {/* Price per day */}
              <div className="space-y-2 mb-4">
                <div className="text-sm font-medium">Price per day</div>
                <div className="px-3 py-3 rounded-lg bg-gray-50 border border-gray-200">
                  <input
                    className="outline-none w-full text-sm bg-transparent"
                    placeholder="100"
                    value={listingDetails.price_per_day}
                    onChange={(e) =>
                      setListingDetails({
                        ...listingDetails,
                        price_per_day: e.target.value,
                      })
                    }
                  />
                </div>
              </div>

              {/* Minimum Stay */}
              <div className="space-y-2 mb-4">
                <div className="text-sm font-medium">Minimum Stay</div>
                <div className="px-3 py-3 rounded-lg bg-gray-50 border border-gray-200">
                  <div className="flex items-center justify-between">
                    <span className="text-sm">Nights</span>
                    <NumberSpin
                      value={listingDetails.minimum_stay}
                      onChange={(value) =>
                        setListingDetails({
                          ...listingDetails,
                          minimum_stay: value,
                        })
                      }
                      min={1}
                    />
                  </div>
                </div>
              </div>

              {/* Cancellation Policy */}
              <div className="space-y-2 mb-4">
                <div className="text-sm font-medium">Cancellation Policy</div>
                
                {/* Add new cancellation policy */}
                <div className="grid grid-cols-2 gap-2 mb-3">
                  <div className="space-y-1">
                    <div className="text-xs text-gray-600">Percentage</div>
                    <div className="px-2 py-2 rounded-lg bg-gray-50 border border-gray-200">
                      <input
                        className="outline-none w-full text-xs bg-transparent"
                        placeholder="50"
                        value={cancellationTemp.percentage}
                        onChange={(e) =>
                          setCancellationTemp({
                            ...cancellationTemp,
                            percentage: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="space-y-1">
                    <div className="text-xs text-gray-600">Deadline (days)</div>
                    <div className="px-2 py-2 rounded-lg bg-gray-50 border border-gray-200">
                      <input
                        className="outline-none w-full text-xs bg-transparent"
                        placeholder="10"
                        value={cancellationTemp.deadline}
                        onChange={(e) =>
                          setCancellationTemp({
                            ...cancellationTemp,
                            deadline: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Add button */}
                <button
                  onClick={handleAddItem}
                  className="flex items-center gap-2 text-xs text-purple-600 hover:text-purple-700"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                  Add cancellation policy
                </button>

                {/* Current cancellation policies */}
                <div className="space-y-2">
                  {listingDetails.cancellation.map((item, i) => (
                    <div key={i} className="px-3 py-2 rounded-lg bg-gray-50 border border-gray-200 flex items-center justify-between">
                      <span className="text-xs">
                        {item.percentage}% refundable {item.deadline} days before
                      </span>
                      <button
                        onClick={() => {
                          const updatedCancellation = listingDetails.cancellation.slice();
                          updatedCancellation.splice(i, 1);
                          setListingDetails({
                            ...listingDetails,
                            cancellation: updatedCancellation,
                          });
                        }}
                        className="text-red-500 hover:text-red-700"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              {/* Action Buttons */}
              <div className="space-y-1 pt-2 border-t border-gray-200">
                <PurpleButton
                  text={
                    <div className="text-center text-xs">
                      {token?.short?.islisted ? "Update Listing" : "List For Rental"}
                    </div>
                  }
                  onClick={handleListNFT}
                  className="py-1 text-xs"
                />
                <div className="grid grid-cols-2 gap-1">
                  <BlackButton 
                    text="Edit Metadata" 
                    onClick={handleEdit}
                    className="text-xs py-1 px-2 h-8"
                  />
                  {token?.short?.islisted ? (
                    <BlackButton 
                      text="Unlist Property" 
                      onClick={handleUnlist}
                      className="text-xs py-1 px-2 h-8"
                    />
                  ) : (
                    <DisabledButton 
                      text="Unlist Property" 
                      className="text-xs py-1 px-2 h-8"
                    />
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Guest Actions (if guest view) */}
          {!location.pathname.includes("dashboard/host") && (
            <div className="bg-white rounded-xl p-4 shadow-sm">
              <h2 className="text-lg font-semibold mb-4">Book this property</h2>
              <div className="space-y-4">
                <PickDate />
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Guests</span>
                  <NumberSpin
                    min={1}
                    value={reservation_guests}
                    onChange={(value) => dispatch(setReservationGuests(value))}
                  />
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Minimum stay</span>
                  <span className="text-sm font-semibold">
                    {token?.short?.minimum_stay ?? 0} nights
                  </span>
                </div>
                <GreenButton
                  text={
                    <div className="flex items-center justify-center gap-2">
                      <span className="text-sm">Get USDC on Nibiru</span>
                      <NibiruIcon className="w-4 h-4" />
                    </div>
                  }
                  onClick={() => window.open('https://express.noble.xyz/transfer?destination=nibiru', '_blank')}
                />
                <PurpleButton
                  text="Reserve"
                  onClick={async () => {
                    if (!myProfile) {
                      toast.error("Please complete your profile before making a reservation");
                      navigate("/dashboard/profile?mode=traveler");
                      return;
                    }

                    // ✅ Check if user is verified before allowing reservation
                    if (!myProfile.isVerified) {
                      toast.error("Please verify your identity before making a reservation. Complete KYC verification in your profile.", {
                        autoClose: 5000
                      });
                      navigate("/dashboard/profile?mode=traveler");
                      return;
                    }

                    if (reservation_guests > (token?.metaData?.essentials?.guests || 0)) {
                      toast.error("Too many guests requested");
                      return;
                    }
                    if (
                      Math.round(
                        (reservation_period.end - reservation_period.start) / 86400
                      ) < token?.short?.minimum_stay
                    ) {
                      toast.error("Your requested stay is shorter than the host's minimum stay");
                      return;
                    }
                    navigate(location.pathname + "/confirm");
                  }}
                />
                <p className="text-xs text-gray-500 text-center">
                  You will not be charged yet. You will be required to sign a message from your wallet to confirm the reservation.
                </p>
                
                {/* Pricing Breakdown */}
                <div className="pt-4 border-t border-gray-200 space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">Total price for the property</span>
                    <div className="flex items-center gap-2">
                      <NUSDIcon className="w-4 h-4" />
                      <span className="text-sm font-medium">
                        {(
                          Math.round(
                            (reservation_period.end - reservation_period.start) / 86400
                          ) * (token?.short?.price_per_day || 0)
                        ).toFixed(2)} USDC
                      </span>
                    </div>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">Coded Estate service fee</span>
                    <div className="flex items-center gap-2">
                      <NUSDIcon className="w-4 h-4" />
                      <span className="text-sm font-medium">
                        {((feeBps * (
                          Math.round(
                            (reservation_period.end - reservation_period.start) / 86400
                          ) * (token?.short?.price_per_day || 0)
                        )) / 10000).toFixed(2)} USDC
                      </span>
                    </div>
                  </div>
                  <div className="flex justify-between items-center pt-2 border-t border-gray-200">
                    <span className="text-sm font-semibold">Total (USDC)</span>
                    <div className="flex items-center gap-2">
                      <NUSDIcon className="w-4 h-4" />
                      <span className="text-lg font-bold text-purple-600">
                        {(Math.round(
                          (reservation_period.end - reservation_period.start) / 86400
                        ) * (token?.short?.price_per_day || 0) +
                        (feeBps * (
                          Math.round(
                            (reservation_period.end - reservation_period.start) / 86400
                          ) * (token?.short?.price_per_day || 0)
                        )) / 10000).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Reviews */}
          <div className="bg-white rounded-xl p-4 shadow-sm">
            <Review tokenId={token?.token_id} />
          </div>

          {/* Map */}
          <div className="bg-white rounded-xl overflow-hidden shadow-sm">
            <div className="p-4 border-b border-gray-100">
              <h2 className="text-lg font-semibold">Location</h2>
            </div>
            <div className="relative h-64">
              <GoogleMap
                center={token?.metaData?.location}
                zoom={zoom}
                mapContainerClassName="w-full h-full"
                options={{
                  styles: mapStyles,
                  gestureHandling: 'greedy',
                  disableDefaultUI: true,
                  zoomControl: false,
                  mapTypeControl: false,
                  scaleControl: false,
                  streetViewControl: false,
                  rotateControl: false,
                  fullscreenControl: false,
                  draggableCursor: 'grab',
                  draggingCursor: 'grabbing',
                  animation: 0,
                  optimized: true,
                }}
              >
                <div className="absolute top-4 right-4 flex flex-col gap-2 z-10">
                  <button
                    className="p-2 rounded-full bg-white shadow-lg hover:bg-gray-50 transition-colors"
                    onClick={() => setZoom(Math.min(zoom + 1, 18))}
                  >
                    <MapPlusIcon className="w-4 h-4" />
                  </button>
                  <button
                    className="p-2 rounded-full bg-white shadow-lg hover:bg-gray-50 transition-colors"
                    onClick={() => setZoom(Math.max(zoom - 1, 10))}
                  >
                    <MapMinusIcon className="w-4 h-4" />
                  </button>
                </div>
                <Marker
                  position={token?.metaData?.location}
                  icon={{
                    url: mapPinIcon,
                    scaledSize: new window.google.maps.Size(40, 40),
                    origin: new window.google.maps.Point(0, 0),
                    anchor: new window.google.maps.Point(20, 34),
                  }}
                />
              </GoogleMap>
            </div>
          </div>
        </div>

        {/* Enhanced Image Modal */}
        <Modal
          open={showImageModal}
          onClose={() => setShowImageModal(false)}
          center
          classNames={{
            modal: "bg-transparent shadow-none",
            overlay: "bg-black/95",
          }}
        >
          <div className="relative w-full h-full flex items-center justify-center">
            <button
              onClick={() => setShowImageModal(false)}
              className="absolute top-4 right-4 z-10 text-white hover:text-gray-300 transition-colors bg-black/30 rounded-full p-2 backdrop-blur-sm"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            
            {loadedImages.length > 1 && (
              <>
                <button
                  onClick={prevImage}
                  className="absolute left-4 top-1/2 transform -translate-y-1/2 z-10 text-white hover:text-gray-300 transition-colors bg-black/30 rounded-full p-3 backdrop-blur-sm"
                >
                  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                <button
                  onClick={nextImage}
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 z-10 text-white hover:text-gray-300 transition-colors bg-black/30 rounded-full p-3 backdrop-blur-sm"
                >
                  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </>
            )}
            
            <PropertyImageWithFallback
              src={loadedImages[currentImageIndex]}
              alt={`${token?.metaData?.buildingName} - Image ${currentImageIndex + 1}`}
              className="max-w-full max-h-full transition-opacity duration-300"
            />
            
            {loadedImages.length > 1 && (
              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-white text-lg font-medium bg-black/50 px-4 py-2 rounded-full backdrop-blur-sm">
                {currentImageIndex + 1} / {loadedImages.length}
              </div>
            )}
          </div>
        </Modal>



        {/* Amenities Modal */}
        <Modal
          open={amenitiesShow}
          onClose={() => setAmenitiesShow(false)}
          center
          classNames={{
            modal: "min-w-[300px] max-w-[90vw] rounded-xl border border-gray-200 shadow-lg",
          }}
        >
          <div className="p-6">
            <h3 className="text-lg font-semibold mb-4">What this place offers</h3>
            <div className="max-h-[70vh] overflow-y-auto space-y-4">
              {token?.metaData?.amenities && Object.entries(token?.metaData?.amenities).map(([category, items]) => (
                <div key={category}>
                  {items.length > 0 && (
                    <h4 className="font-medium text-gray-900 mb-2">{category}</h4>
                  )}
                  <div className="space-y-2">
                    {items.map((item) => (
                      <div key={item} className="flex items-center gap-3 text-sm">
                        {renderAmenity(item)}
                        <span className="text-gray-700">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Modal>

        {/* Profile Required Modal */}
        <ProfileRequiredModal
          isOpen={showProfileModal}
          onClose={() => setShowProfileModal(false)}
          onCreateProfile={() => {
            setShowProfileModal(false);
            navigate("/dashboard/profile?mode=traveler");
          }}
          action="contact hosts"
        />
          </Fade>
        </div>
      </div>
    </div>
  );
};